import React from 'react'
import { AvatarGenerator } from 'random-avatar-generator'
const GenerateAvatar = new AvatarGenerator()

interface NFTUserAvatarProps {
  profileImgUrl?: string
  accountAddress: string
  height?: number
  width?: number
  style?: React.CSSProperties
}

const NFTUserAvatar = (props: NFTUserAvatarProps) => {
  return (
    <img
      src={
        props.profileImgUrl?.length ? props.profileImgUrl : GenerateAvatar.generateRandomAvatar(props.accountAddress).replace("&avatarStyle=Circle", "")
      }
      height={props.height || 200}
      width={props.width || 200}
      style={props.style}
    />
  )
}
export default NFTUserAvatar
